import { useEffect, useCallback, useState } from 'react';
import axios from 'Axios';
import { useParams } from 'react-router';
import { api, Names } from 'Utils';
import {
	UserInfoForm,
	UserPasswordForm,
	UserContentList,
	UserUploadContent
} from 'Elements';

export const UserContent = () => {
	const params = useParams();
	const tab = params.tabId;
	const [user, setUser] = useState({});

	const getProfile = useCallback(() => {
		axios.post(api.profile).then((res) => {
			const data = res.data;
			if (data.success) {
				const result = data.result;
				setUser(result);
			}
		});
	}, []);

	useEffect(() => {
		getProfile();
	}, [getProfile]);

	return (
		<div className="col-lg-9 col-xl-10">
			{tab === Names.profile.title && (
				<div>
					<UserInfoForm user={user} />
					<UserPasswordForm user={user} />
				</div>
			)}
			{tab === Names.content.title && <UserContentList />}
			{tab === Names.upload.title && <UserUploadContent />}
		</div>
	);
};
